var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('block-title',{staticClass:"mb-0",attrs:{"title":"Map"}}),_c('sunburst-graph',{staticClass:"max-w-lg",attrs:{"data":_vm.parsedData,"node-id":_vm.selectedActorID}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }